import { useTranslation } from '@sib/i18n';
import { useGlobalSearchPanel } from './use-global-search-panel';

export const useGlobalSearchBar = () => {
  const { t } = useTranslation();
  const panel = useGlobalSearchPanel();

  return {
    ...panel,
    placeholder: t('components.topbar.searchPlaceholder'),
  };
};
